module.exports = __webpack_public_path__ + "static/media/26-iveco-mercedes.7ebceb78.jpg";